export default function React_PropsDestructuring() {
  return (
    <div>
      <h1>React_PropsDestructuring Component</h1>
      <p>This is the React_PropsDestructuring tutorial page.</p>
    </div>
  );
}
